import { c as _c } from "react/compiler-runtime";
import { fetchProjects } from "@store/projects/projects-slice-thunk";
import { useAppDispatch } from "@store/store-helper";
import { ButtonEvents } from "@utils/track-event/track-event-list";
import { useTrackEvent } from "@utils/track-event/use-track-event";
import { useCallback, useEffect, useRef } from "react";
/** Custom hook that returns a function to fetch the next page of projects */
export function useFetchNextProjectsPage(t0) {
  const $ = _c(16);
  const {
    companyId,
    projectArchivingState,
    sortBy,
    nextPageCursor,
    search,
    groupId
  } = t0;
  const dispatch = useAppDispatch();
  const {
    trackEvent
  } = useTrackEvent();
  const index = useRef(1);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      index.current = 1;
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== companyId || $[2] !== groupId || $[3] !== projectArchivingState || $[4] !== search || $[5] !== sortBy) {
    t2 = [companyId, projectArchivingState, sortBy, search, groupId];
    $[1] = companyId;
    $[2] = groupId;
    $[3] = projectArchivingState;
    $[4] = search;
    $[5] = sortBy;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  useEffect(t1, t2);
  let t3;
  if ($[7] !== companyId || $[8] !== dispatch || $[9] !== groupId || $[10] !== nextPageCursor || $[11] !== projectArchivingState || $[12] !== search || $[13] !== sortBy || $[14] !== trackEvent) {
    t3 = async () => {
      if (nextPageCursor) {
        index.current = index.current + 1;
        trackEvent({
          name: ButtonEvents.loadMore,
          props: {
            data: `${projectArchivingState} projects`,
            source: groupId ? "Group projects" : "Projects page",
            sort: sortBy,
            index: index.current
          }
        });
        await dispatch(fetchProjects({
          companyId,
          projectArchivingState,
          next: nextPageCursor,
          sortBy,
          search,
          groupId
        }));
      }
    };
    $[7] = companyId;
    $[8] = dispatch;
    $[9] = groupId;
    $[10] = nextPageCursor;
    $[11] = projectArchivingState;
    $[12] = search;
    $[13] = sortBy;
    $[14] = trackEvent;
    $[15] = t3;
  } else {
    t3 = $[15];
  }
  const fetchNextProjectsPage = t3;
  return fetchNextProjectsPage;
}